module.exports = __webpack_public_path__ + "static/media/bg_10.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg_10.png
// module id = 55
// module chunks = 0